import { ca } from '@cian/analytics';

export function trackGoToFormClick(label?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LegalCheckPromo',
    action: 'Click',
    label: `GoToForm/${label}`,
  });
}

export function trackDownloadReportClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LegalCheckPromo',
    action: 'Click',
    label: 'download',
  });
}
